import { Components } from 'formiojs';
import FieldComponent from 'formiojs/components/_classes/field/Field';

declare let google: any; // If using Google Maps API (optional)

export class GeoFenceComponent extends FieldComponent {
  refs: any;
    component: any;
    loadRefs: any;
    addEventListener: any;
    setValue: any;
  static schema(...extend: any[]) {
    return FieldComponent.schema(
      {
        type: 'geofence',
        label: 'Geo-Fence',
        key: 'geofence',
        centerLat: 28.6139,   // Default: New Delhi
        centerLng: 77.2090,
        radius: 1000,         // in meters
        showMap: true,
      },
      ...extend
    );
  }

  static builderInfo = {
    title: 'Geo-Fence',
    group: 'advanced',
    icon: 'map-marker',
    weight: 70,
    schema: GeoFenceComponent.schema(),
  };

  render(children: any) {
    return super.render(`
      <div ref="geofenceContainer" class="geofence-container">
        <button type="button" ref="detectBtn" class="btn btn-primary">Detect My Location</button>
        <div ref="statusMessage" class="mt-2 text-info">Waiting for location...</div>
        ${this.component.showMap ? '<div ref="map" style="height:300px;width:100%;margin-top:10px;"></div>' : ''}
      </div>
    `);
  }

  attach(element: any) {
    const refs = super.attach(element);

    // ✅ Load refs properly
    this.loadRefs(element, {
      detectBtn: 'single',
      statusMessage: 'single',
      map: 'single',
    });

    if (this.refs.detectBtn) {
      this.addEventListener(this.refs.detectBtn, 'click', () => {
        this.detectLocation();
      });
    }

    return refs;
  }

  detectLocation() {
    const centerLat = this.component.centerLat;
    const centerLng = this.component.centerLng;
    const radius = this.component.radius;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        const userLat = pos.coords.latitude;
        const userLng = pos.coords.longitude;

        const distance = this.calculateDistance(centerLat, centerLng, userLat, userLng);

        if (this.refs.statusMessage) {
          if (distance <= radius) {
            this.refs.statusMessage.innerHTML = `<span style="color:green">✅ You are inside the geo-fence (Distance: ${distance.toFixed(2)} m)</span>`;
          } else {
            this.refs.statusMessage.innerHTML = `<span style="color:red">❌ You are outside the geo-fence (Distance: ${distance.toFixed(2)} m)</span>`;
          }
        }

        this.setValue({
          userLat,
          userLng,
          distance,
          insideFence: distance <= radius,
        });

        // ✅ Show Google Map if enabled
        if (this.component.showMap && this.refs.map && typeof google !== 'undefined') {
          const map = new google.maps.Map(this.refs.map, {
            center: { lat: centerLat, lng: centerLng },
            zoom: 15,
          });

          new google.maps.Circle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.2,
            map,
            center: { lat: centerLat, lng: centerLng },
            radius: radius,
          });

          new google.maps.Marker({
            position: { lat: userLat, lng: userLng },
            map,
            title: "Your Location",
          });
        }
      });
    } else {
      if (this.refs.statusMessage) {
        this.refs.statusMessage.innerHTML = "❌ Geolocation not supported!";
      }
    }
  }

  // Haversine formula for distance
  calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371e3; // Earth radius in meters
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lon2 - lon1) * Math.PI / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // distance in meters
  }
}

// ✅ Register component
Components.addComponent('geofence', GeoFenceComponent);
